import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { TRANSLOCO_SCOPE } from '@ngneat/transloco';

@Component({
  selector: 'app-review-card',
  templateUrl: './review-card.component.html',
  styleUrls: ['./review-card.component.scss']
})
export class ReviewCardComponent implements OnInit {

  @Input() public name = '';
  @Input() public imageUrl = '';
  @Input() public experienceName = '';
  @Input() public rating = 0;
  @Input() public max = 5;
  @Input() public comment = '';
  @Input() public bottom_border = true;
  @Input() public  isFirstItem: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
